export default __webpack_public_path__ + "static/media/plot_card_pink.8c41ba8a.png";